import React from 'react';

import { useTheme } from '@tmap/mmm-style-guide/src/Theming';
import { styled } from '@tmap/mmm-style-guide/src/styled';

const Background = styled('div', {
  shouldForwardProp: (p) => !['primary', 'secondary', 'cutoff'].includes(p),
})(({ primary, secondary, cutoff }) => ({
  background: `linear-gradient(0deg, ${secondary} ${cutoff}, ${primary} 0%)`,
}));

function TwoTone(props) {
  const theme = useTheme();
  const {
    children,
    primary = theme.palette.primary.veryDark,
    secondary = 'transparent',
    cutoff = '40%',
  } = props;

  return (
    <Background primary={primary} secondary={secondary} cutoff={cutoff}>
      {children}
    </Background>
  );
}

export default TwoTone;
